/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
  // 지원자 목록
  async index(data?: any) {
    return camelize(
      await $axios.get(
        `/campaign/${data.campaignId}/product/${data.productId}/applicants`,
        snakelize({ params: data })
      )
    );
  },

  // 지원자 저장
  async store(data?: any) {
    return camelize(
      await $axios.post(
        `/campaign/${data.campaignId}/product/${data.productId}/applicants`,
        snakelize(data)
      )
    );
  },

  async importApplicantsData(data?: any) {
    const formData = new FormData();
    formData.append("file", data.file);
    formData.append("brand_token", data.brandToken);

    return camelize(
      await $axios.post(`/import/campaign/applicants`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    );
  },
});
